export var InfoCardDetailType;
(function (InfoCardDetailType) {
    InfoCardDetailType["ordersInRegisterStatistics"] = "orders-in-register-statistics";
    InfoCardDetailType["providersPackagesInOrdersStatistics"] = "providers-packages-in-orders-statistics";
    InfoCardDetailType["suppliersPackagesInOrdersStatistics"] = "suppliers-packages-in-orders-statistics";
    InfoCardDetailType["monthlyStatistics"] = "monthly-statistics";
    InfoCardDetailType["dateStatistics"] = "date-statistics";
    InfoCardDetailType["indicationRestrictionPaymentStatistics"] = "indication-restriction-payment-statistics";
    InfoCardDetailType["insuranceCompaniesPaymentStatistics"] = "insurance-companies-payment-statistics";
    InfoCardDetailType["positiveListStatistics"] = "positive-list-statistics";
    InfoCardDetailType["packageStatistics"] = "package-statistics";
    InfoCardDetailType["monthlyMultiValueStatistics"] = "monthly-multi-value-statistics";
    InfoCardDetailType["otherStatisticsLink"] = "other-statistics-link";
    InfoCardDetailType["unitPricesFromRegisterStatistics"] = "unit-prices-from-register-statistics";
    InfoCardDetailType["monthlyPackageBalanceStatistics"] = "monthly-package-balance-statistics";
    InfoCardDetailType["monthlyDistrictBalanceStatistics"] = "monthly-district-balance-statistics";
})(InfoCardDetailType || (InfoCardDetailType = {}));
export var Currency;
(function (Currency) {
    Currency["CZK"] = "K\u010D";
})(Currency || (Currency = {}));
export var InfoCardDetailsError;
(function (InfoCardDetailsError) {
})(InfoCardDetailsError || (InfoCardDetailsError = {}));
var InfoCardDetailsRequest = /** @class */ (function () {
    function InfoCardDetailsRequest(id, query) {
        this.knownErrorCodes = Object.values(InfoCardDetailsError);
        this.path = "info-cards/".concat(encodeURIComponent(id), "/statistics?").concat(String(query));
    }
    return InfoCardDetailsRequest;
}());
export { InfoCardDetailsRequest };
